package com.essntl.features.client.data.di

import org.koin.core.annotation.ComponentScan
import org.koin.core.annotation.Module

@Module
@ComponentScan("com.essntl.features.client.data")
class ClientModule
